export default "__VITE_PUBLIC_ASSET__9bd870fa__"